import "./webcam-map.scss"
import { BaseComponent } from "utils/base-component"
import type { WebcamMapConfig } from "./map"

export class WebcamMap extends BaseComponent<WebcamMapConfig[]> {
  static cssClass = "webcam-map"

  init() {
    const mapIdStr = this.root.dataset.mapId
    if (mapIdStr === undefined) return

    const mapId = parseInt(mapIdStr, 10)
    if (this.config[mapId] === undefined) return

    import(/* webpackChunkName: 'webcam-map' */ "./map").then((module) => {
      const WebcamMapModule = module.default
      // eslint-disable-next-line no-new
      new WebcamMapModule(this.root, this.config[mapId])
    })
  }
}
